/* eslint-disable unicorn/filename-case -- TODO rename later */
export enum AccessActionType {
  create,
  remove,
  update,
}
